var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgErrorInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A97B3F9C-B8B7-4682-89A8-2C8EF87C50D2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Customer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 404,
    transform: "translate(-158, -286)",
    fill: "#777777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(78, 286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(80, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,0 C46.5685425,0 60,13.4314575 60,30 C60,46.5685425 46.5685425,60 30,60 C13.4314575,60 0,46.5685425 0,30 C0,13.4314575 13.4314575,0 30,0 Z M30,4 C15.6405965,4 4,15.6405965 4,30 C4,44.3594035 15.6405965,56 30,56 C44.3594035,56 56,44.3594035 56,30 C56,15.6405965 44.3594035,4 30,4 Z",
    id: "Oval",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(28, 16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 7,
    width: 4,
    height: 21
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 4,
    height: 4
  }))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorInfo);
export default __webpack_public_path__ + "static/media/error-info.2acfed9df93ff5cbb51df08841534f90.svg";
export { ForwardRef as ReactComponent };